import 'jquery.cookie/jquery.cookie'

// 閲覧者にサイトごとcookieを与えてアクセス回数を判断
export const accessCookie = function (rest) {
  var lang = $.cookie('lang')
  if (!$.cookie(rest)) { // 初回アクセス
    // console.log('accessCookie : 初回')
    // console.log('accessCookie :' + rest)
    $(window).load(function () {
      setTimeout(function () {
        $('#js-note-modal').modal('show')
      }, 500)
      $('#js-note-modal').modal('show')
      // $.cookie(rest,lang, { expires: 1, path: '/' + rest })
      $.cookie(rest, lang, {expires: 1, path: '/'})
    })
  } else {
    // 2回目以降のアクセス
    // console.log('accessCookie : 2回目以降')
    // console.log('accessCookie :' + rest)
  }
}



// WEBPACK FOOTER //
// ./src/js/lib/cookie.js